import styles from "./Skills.module.scss";
import images from "./images";
import { useTranslation } from "react-i18next";

const skillsData = {
    frontend: [
        { name: "React", img: images.react },
        { name: "TypeScript", img: images.js },
        { name: "Next.js", img: images.react },
        { name: "HTML", img: images.html },
        { name: "CSS", img: images.css },
        { name: "JavaScript", img: images.js },
    ],
    backend: [
        { name: "NestJS", img: images.nodejs },
        { name: "Node.js", img: images.nodejs },
        { name: "Java 17", img: images.java },
        { name: "Spring Boot", img: images.spring },
        { name: ".NET", img: images.csharp },
        { name: "C#", img: images.csharp },
    ],
    database: [
        { name: "SQL Server", img: images.sqlServer },
        { name: "PostgreSQL", img: images.sqlServer },
        { name: "Oracle PL/SQL", img: images.sqlServer },
        { name: "MongoDB", img: images.mongodb },
    ],
    devops: [
        { name: "Docker", img: images.docker },
        { name: "Kubernetes", img: images.docker },
        { name: "AWS", img: images.aws },
        { name: "CI/CD", img: images.git },
        { name: "Git", img: images.git },
    ]
};

export default function Skills() {
    const { t } = useTranslation();

    return (
        <div id="Skills" className={`${styles.skills} container`}>
            <h1 className={styles.skillsTitle}>{t("Skills.title")}</h1>

            <div className={styles.skillsCategories}>
                <div className={styles.skillCategory}>
                    <h3>{t("Skills.frontend")}</h3>
                    <div className={styles.skillsContainer}>
                        {skillsData.frontend.map(skill => (
                            <div className={styles.skillItem} key={skill.name}>
                                <img src={skill.img} alt={skill.name} className={styles.skillImage} />
                                <p>{skill.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.skillCategory}>
                    <h3>{t("Skills.backend")}</h3>
                    <div className={styles.skillsContainer}>
                        {skillsData.backend.map(skill => (
                            <div className={styles.skillItem} key={skill.name}>
                                <img src={skill.img} alt={skill.name} className={styles.skillImage} />
                                <p>{skill.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.skillCategory}>
                    <h3>{t("Skills.database")}</h3>
                    <div className={styles.skillsContainer}>
                        {skillsData.database.map(skill => (
                            <div className={styles.skillItem} key={skill.name}>
                                <img src={skill.img} alt={skill.name} className={styles.skillImage} />
                                <p>{skill.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.skillCategory}>
                    <h3>{t("Skills.devops")}</h3>
                    <div className={styles.skillsContainer}>
                        {skillsData.devops.map(skill => (
                            <div className={styles.skillItem} key={skill.name}>
                                <img src={skill.img} alt={skill.name} className={styles.skillImage} />
                                <p>{skill.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
